import { useCallback } from 'react';
import { useAsyncQueue } from './useAsyncQueue';

const options = {
  cleanupBeforeNew: true,
  debug: true,
  cancelPending: true,
};

export function useAsyncOperation<T = any>(initializer: () => Promise<T>, cleanup?: () => Promise<void>) {
  const { enqueue, cancelAll } = useAsyncQueue(options);

  const execute = useCallback(async (): Promise<T> => {
    try {
      const result = await enqueue(initializer, cleanup);
      return result;
    } catch (err) {
      console.log('Error:', err);
      const error = err as Error;
      throw error;
    }
  }, [enqueue, initializer, cleanup]);

  const reset = useCallback(() => {
    cancelAll();
  }, [cancelAll]);

  return {
    execute,
    reset,
  };
}
